import { ReactComponent as ZoomIn } from '@public/icons/zoom-in.svg';
import Icon from '../atoms/Icon';

const IconZoomIn = (props) => <Icon as={ZoomIn} {...props} />;

IconZoomIn.propTypes = Icon.propTypes;

export default IconZoomIn;
